import { routes } from '@/routes/routes';
import {
  CartShoppingSolid,
  ChartLineSolid,
  CheckToSlotSolid,
  CircleNodesSolid,
  EnvelopeSolid,
  HouseSolid,
  MedalSolid,
  MegaphoneSolid,
  RightFromBracketSolid,
  StoreSolid,
  WalletSolid,
} from '@/assets/icons/iconComponents/navigation';

/**
 * @param {number} cartCount quantity of items in user cart
 * @param {number} votingCount pending voting proposals
 * @param {number} notificationCount user notifications
 * @returns {object} routing object with badge counts
 */
export const authRoutes = (navBadges, isAmbassadorAndFeatureEnabled, isNftEnabled) => {
  const baseRoutes = [
    {
      ...routes.loggedInHome,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.loggedInHome.icon ? routes.loggedInHome.icon : <HouseSolid className="navIcon" />,
    },
    {
      key: 'dashboard',
      value: 'Dashboard',
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.dashboard.icon ? routes.dashboard.icon : <ChartLineSolid className="navIcon" />,
      subitems: [
        {
          ...routes.nodes,
          // Use icon from routes (respects brand customization) or fallback to default component
          icon: routes.nodes.icon ? routes.nodes.icon : <CircleNodesSolid className="navIcon" />,
          badgeContent: navBadges.nodes,
        },
        {
          ...routes.rewards,
          // Use icon from routes (respects brand customization) or fallback to default component
          icon: routes.rewards.icon ? routes.rewards.icon : <MedalSolid className="navIcon" />,
        },
        // Conditionally include the brandAmbassador route
        ...(isAmbassadorAndFeatureEnabled
          ? [
              {
                ...routes.brandAmbassador,
                icon: <MegaphoneSolid className="navIcon" />,
              },
            ]
          : []),
        {
          ...routes.wallet,
          // Use icon from routes (respects brand customization) or fallback to default component
          icon: routes.wallet.icon ? routes.wallet.icon : <WalletSolid className="navIcon" />,
          badgeContent: navBadges.wallet,
        },
        ...(isNftEnabled
          ? [
              {
                ...routes.nfts,
              },
            ]
          : []),
      ],
    },
    {
      ...routes.store,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.store.icon ? routes.store.icon : <StoreSolid className="navIcon" />,
    },
    {
      ...routes.cart,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.cart.icon ? routes.cart.icon : <CartShoppingSolid className="navIcon" />,
      badgeContent: navBadges.cart,
    },
    {
      ...routes.voting,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.voting.icon ? routes.voting.icon : <CheckToSlotSolid className="navIcon" />,
      badgeContent: navBadges.voting,
    },
    {
      ...routes.support,
      // Use icon from routes (respects brand customization) or fallback to default component
      icon: routes.support.icon ? routes.support.icon : <EnvelopeSolid className="navIcon" />,
    },
  ];

  return baseRoutes;
};

export const noAuthRoutes = [
  {
    ...routes.store,
    // Use icon from routes (respects brand customization) or fallback to default component
    icon: routes.store.icon ? routes.store.icon : <StoreSolid className="navIcon" />,
  },
  {
    ...routes.support,
    // Use icon from routes (respects brand customization) or fallback to default component
    icon: routes.support.icon ? routes.support.icon : <EnvelopeSolid className="navIcon" />,
  },
];

export const accountRoutes = {
  manageAccount: { ...routes.manageAccountProfile },
  logout: { ...routes.logout, icon: <RightFromBracketSolid className="navIcon" /> },
};
